export const ThemeColors = {
  primary: '#130056',
  'primary-dark': '#130056',
  secondary: '#21387',
  success: '#2a6550',

  warning: '#fde68a',
  'warning-light': '#fffbeb',
  'warning-light-contrast': '#b4540a',

  error: '#de0a01',
  info: '#21387',

  'luminous-lavender': '#cdcfff',
  'luminous-lavender-2': '#bfc3ed',
  'semilight-lavender': '#dedffb',
  'semilight-lavender-2': '#ebecff',
  'light-lavender': '#F5F5FF',
  'extralight-purple': 'rgb(239, 239, 255)',
  'extralight-purple-2': '#fbfbff',
  purple: 'rgb(125,77,255)',
  'light-purple': 'rgb(125,77,255, 0.27)',
  'blue-purple': 'rgb(70,0,255)',
  'blue-purple-2': '#4500ff',
  'blue-purple-light': '#4e49fc',
  // Text Colors
  dark: '#212121',
  'semidark-gray': 'rgb(61,61,61)',
  light: '#ffffff',
  'light-2': '#c0c0c0',
  'gray-brown': 'rgb(65,65,65)',
  'gray-2': '#e0e0e0',

  'light-background-1': '#ffffff',
  'light-background-2': '#f9f9fa',
  'light-background-3': '#f4f4f5',
  'light-background-4': '#e4e4e5',
  'border-base': '#E0E0E0',
  'blue-gray': 'rgb(129,134,180)',
  'synapse-silver': '#8186b4',
  'synapse-silver-2': '#9894cf',
  'light-synapse-silver': '#c7cae0',

  'status-blue-purple': '#4600ff4a',
  'status-blue-purple-2': '#0000a9',
  'status-gray': '#f3f3f3',
  'status-green': '#bde2d5',
  'status-orange': '#ffc7ba',
  'status-blue-gray': '#e4e4ff',
  'status-border-green': '#b1d4c8',
  'status-border-purple': '#c1aef5',
  'status-border-orange': '#f7c1b4',
  'status-border-blue-gray': '#d9d9f2',
}

export type ThemeColors = keyof typeof ThemeColors
